// @flow

import * as React from 'react';
import {useAccount} from 'docs/data';
import {normalizeHostname} from 'docs/util';

type LinkProps = {|
  href: string,
  title?: string,
  id?: string,
  className?: string,
  children?: React.Node,
|};

const getHref = (href: string, hosts: {[string]: string} = {}): string => {
  const looksLikeAnEmail = !!href.split(/\?|#/)[0].match(/\S+@\S+\.\S+/);
  if (looksLikeAnEmail) {
    return href.match(/^mailto:/) ? href : `mailto:${href}`;
  }
  return normalizeHostname(href, hosts);
};

export const Link = ({id, className, href, title, children}: LinkProps) => {
  const {account} = useAccount();
  return (
    <a
      id={id}
      className={className}
      title={title}
      href={getHref(href, account.hosts)}
    >
      {children}
    </a>
  );
};
